import { observable } from 'mobx';

class Sleva {

    @observable public name: string;
    @observable public value: number;
    @observable public id: string;

    public clone(): Sleva {
        const newDen: Sleva = new Sleva();
        newDen.loadFromEntity(this);
        return newDen;
    }

    public loadFromJSON(json: any): Sleva {
        this.id = json.id;
        this.name = json.name;
        this.value = json.value;
        return this;
    }

    public loadFromEntity(ent: Sleva): Sleva {
        this.id = ent.id;
        this.name = ent.name;
        this.value = ent.value;
        return this;
    }

}

export default Sleva;


// WEBPACK FOOTER //
// ./src/models/Sleva.tsx